// Pop-up: full reset with typed confirmation and an automatic snapshot first.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function ResetModal({ busy, refresh, resetModal, resetSnapshot, resetTyped, runReset, setResetModal, setResetTyped, tab }) {
  return (
    <>
      {resetModal && (
        <div className="modal-backdrop" onClick={() => { if (resetModal === 'open' || resetModal === 'done') setResetModal(null); }}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 480, maxWidth: 640 }}>
            <h3 style={{ color: '#991b1b', marginTop: 0 }}>Full reset of tip data</h3>
            {resetModal === 'open' && (
              <>
                <p>This will:</p>
                <ol style={{ marginTop: 0 }}>
                  <li><strong>Snapshot</strong> tips_excel + tips_google into timestamped archive tables.</li>
                  <li><strong>Wipe</strong> tips_excel and tips_google.</li>
                  <li><strong>Re-import</strong> from the bundled historical seed and pull the full Google Sheet.</li>
                </ol>
                <p>Type <code>RESET</code> below to enable the button. Anything else keeps it disabled.</p>
                <input type="text" value={resetTyped} onChange={e => setResetTyped(e.target.value)} autoFocus
                       placeholder="type RESET" style={{ width: '100%', padding: '0.5rem', fontSize: '1em', fontFamily: 'monospace' }} />
                <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
                  <button className="refresh-btn" onClick={runReset} disabled={resetTyped !== 'RESET' || busy}
                          style={{ background: resetTyped === 'RESET' ? '#b91c1c' : '#aaa' }}>
                    Snapshot + wipe + re-import
                  </button>
                  <button className="refresh-btn" onClick={() => setResetModal(null)} style={{ background: '#888' }}>Cancel</button>
                </div>
              </>
            )}
            {resetModal === 'snapshotting' && <p>Snapshotting current data… do not close this tab.</p>}
            {resetModal === 'wiping' && (
              <>
                <p>Wipe + re-import in progress. <strong>Do not close this tab.</strong></p>
                {resetSnapshot && (
                  <p className="small">Snapshot retained: <code>{resetSnapshot.archives.tips_excel}</code> ({resetSnapshot.rowCounts.tips_excel} rows) + <code>{resetSnapshot.archives.tips_google}</code> ({resetSnapshot.rowCounts.tips_google} rows). Restore via Supabase SQL editor if needed.</p>
                )}
              </>
            )}
            {resetModal === 'done' && (
              <>
                <p style={{ color: '#16a34a' }}>Reset complete. {resetSnapshot && (
                  <>Snapshot retained: <code>{resetSnapshot.archives.tips_excel}</code>.</>
                )}</p>
                <button className="refresh-btn" onClick={() => setResetModal(null)} style={{ background: '#16a34a' }}>OK</button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
